import { render, staticRenderFns } from "./crm-create-cost.vue?vue&type=template&id=3c6a2dd4&"
import script from "./crm-create-cost.vue?vue&type=script&lang=js&"
export * from "./crm-create-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports